module.exports = __webpack_public_path__ + "static/media/like-hover.720ba552.png";